import { Component, inject, input, InputSignal, Signal } from '@angular/core';
import { EApplicationForm } from '../../forms/e-application.form';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { Store } from '@ngrx/store';
import { ValidationErrorsComponent } from '../../../../common/validation-errors/validation-errors.component';
import { AccordionGroupComponent } from '../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../common/accordion-item/accordion-item.component';
import { SubpageContentByUrlPipe } from '../../../../pipes/subpage-content-by-url.pipe';
import { AlertComponent } from '../../../../common/alert/alert.component';
import {
  DrawAndModifyTerrainComponent
} from '../../../../common/draw-and-modify-terrain/draw-and-modify-terrain.component';
import { FileUploaderComponent } from '../../../../common/file-uploader/file-uploader.component';
import { SubpageAppEntitySubpageRead } from '../../../../openapi';
import { selectSubpages } from '../../../../store/selectors/app.selectors';
import { SessionService } from '../../../../services/ssession.service';

@Component({
  selector: 'app-e-application-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    AccordionGroupComponent,
    AccordionItemComponent,
    SubpageContentByUrlPipe,
    AlertComponent,
    DrawAndModifyTerrainComponent,
    FileUploaderComponent
  ],
  templateUrl: './e-application-form.component.html'
})
export class EApplicationFormComponent {
  public Validators = Validators;

  public authed: boolean = SessionService.Authed();

  public form: InputSignal<EApplicationForm | undefined> = input<EApplicationForm>();

  public subpages: Signal<SubpageAppEntitySubpageRead[]> = inject(Store).selectSignal(selectSubpages);

  public showDrawTerrain = true;

  public onCancelDraw(): void {
    this.showDrawTerrain = false;
  }
}
